import { parse } from "date-fns";
import { omitBy } from "lodash-es";
import { casesActions } from "configs";
import { useCurrentCase, useDispatch, useParams } from "duck";
import { useUpdateFluidAndTemperatureMutation } from "requests";

export const useUpdateFluidAndTemperature = (caseCreationDate?: Date) => {
  const dispatch = useDispatch();
  const { id: caseId } = useParams();
  const [update] = useUpdateFluidAndTemperatureMutation();
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);

  return (
    curValue: number | null,
    cellValue: any,
    name: string,
    time: string
  ) => {
    if (cellValue?.fluidTemperatureId && caseCreationDate) {
      const isTemperature = name.startsWith("Temperature");
      const isFluidRate = name === "Fluid Rate (mLs/hr)";
      const isVolumeInfused = name.endsWith("Volume Infused");
      const timeMonitoring = parse(
        time,
        "h:mm a",
        caseCreationDate
      ).toISOString();

      const variables = omitBy(
        {
          timeMonitoring,
          ...(isFluidRate ? { fluidRate: curValue } : {}),
          ...(isVolumeInfused ? { volumeInfused: curValue } : {}),
          ...(isTemperature ? { temperature: curValue } : {})
        },
        value => value === undefined
      );

      if (shouldSync) {
        dispatch(
          casesActions.updateFluidAndTemperature({
            data: {
              _id: cellValue.fluidTemperatureId,
              ...variables
            },
            _id: caseId
          })
        );

        return update({
          variables: {
            input: {
              _id: cellValue.fluidTemperatureId,
              ...variables
            }
          }
        });
      }

      dispatch(
        casesActions.updateFluidAndTemperature({
          data: {
            ...(typeof cellValue.fluidTemperatureId === "number"
              ? { _id: cellValue.fluidTemperatureId }
              : { fakeId: cellValue.fluidTemperatureId }),
            ...variables
          },
          _id: caseId
        })
      );
    }
  };
};
